export const ENV = () => {
  if (process.env.REACT_APP_STAGE === 'dev') {
    return {
      REACT_APP_API_URL: process.env.REACT_APP_DEV_API_URL || 'http://localhost:3011/api/v1/',
      REACT_APP_API_V2_URL: process.env.REACT_APP_DEV_API_V2_URL,
      REACT_APP_API_V3_URL: process.env.REACT_APP_DEV_API_V3_URL,
      REACT_APP_BE_API_URL: process.env.REACT_APP_DEV_BE_API_V2_URL,
      REACT_APP_PUBLIC_KEY: process.env.REACT_APP_DEV_PUBLIC_KEY || 'pk_test_placeholder',
      REACT_APP_DOMAIN: process.env.REACT_APP_DEV_DOMAIN,
      REACT_APP_DOMAIN_SOCKETID: process.env.REACT_APP_DEV_DOMAIN_SOCKETID,
      REACT_APP_TEST_GIPHY: process.env.REACT_APP_DEV_TEST_GIPHY,
      REACT_APP_SHORTURL: process.env.REACT_APP_DEV_SHORTURL,
      REACT_APP_SHORTURL_INTERNATIONAL: process.env.REACT_APP_SHORTURL_INTERNATIONAL,
      REACT_APP_OPTOUT: process.env.REACT_APP_DEV_OPTOUT,
      REACT_APP_OPTOUT_INTERNATIONAL: process.env.REACT_APP_DEV_OPTOUT_INTERNATIONAL,
      REACT_APP_CELLCAST: process.env.REACT_APP_DEV_CELLCAST,
      REACT_APP_GOOGLERECAPCHA: process.env.REACT_APP_DEV_GOOGLERECAPCHA,
      REACT_APP_GOOGLE_CLIENT_ID: process.env.REACT_APP_DEV_GOOGLE_CLIENT_ID,
      REACT_APP_GHL_BASE_URL: process.env.REACT_APP_DEV_GHL_BASE_URL,
      REACT_APP_GHL_CLIENT_ID: process.env.REACT_APP_DEV_GHL_CLIENT_ID,
      REACT_APP_FE_URL: process.env.REACT_APP_FE_URL,
      REACT_APP_TAWK_TO_PROPERTY_ID: process.env.REACT_APP_TAWK_TO_PROPERTY_ID,
      REACT_APP_TAWK_TO_WIDGET_ID: process.env.REACT_APP_TAWK_TO_WIDGET_ID,

      REACT_APP_JOBADDER_BASE_URL: process.env.REACT_APP_JOBADDER_BASE_URL,
      REACT_APP_JOBADDER_CLIENT_ID: process.env.REACT_APP_JOBADDER_CLIENT_ID,

      REACT_APP_HUBSPOT_CLIENT_SECRET: process.env.REACT_APP_HUBSPOT_CLIENT_SECRET,
      REACT_APP_HUBSPOT_CLIENT_ID: process.env.REACT_APP_HUBSPOT_CLIENT_ID,
      REACT_APP_HUBSPOT_BASE_URL: process.env.REACT_APP_HUBSPOT_BASE_URL,
      REACT_APP_ENABLE_ONBOARDING: process.env.REACT_APP_ENABLE_ONBOARDING,

      REACT_APP_US_URL: process.env.REACT_APP_DEV_US_URL,
      REACT_APP_UK_URL: process.env.REACT_APP_DEV_UK_URL,
      REACT_APP_AU_URL: process.env.REACT_APP_DEV_AU_URL,
      REACT_APP_NZ_URL: process.env.REACT_APP_DEV_NZ_URL,
      REACT_APP_ID_URL: process.env.REACT_APP_DEV_ID_URL,

      REACT_APP_S3_URL: process.env.REACT_APP_DEV_S3_URL,
      REACT_APP_S3_WALLET_CARD_URL: process.env.REACT_APP_DEV_S3_WALLATE_CARD_URL,
      REACT_APP_S3_WALLET_CARD_PREVIEW_URL: process.env.REACT_APP_DEV_S3_WALLATE_CARD_PREVIEW_URL,
      REACT_APP_S3_WALLET_CARD_PREVIEW_BUCKET_NAME:
        process.env.REACT_APP_DEV_S3_WALLATE_CARD_PREVIEW_BUCKET_NAME,
      REACT_APP_MAX_FILE_SIZE: process.env.REACT_APP_DEV_MAX_FILE_SIZE,
      REACT_APP_S3_VOICE_URL: process.env.REACT_APP_DEV_S3_VOICE_URL,
      REACT_APP_S3_VOICE_BUCKET_NAME: process.env.REACT_APP_DEV_S3_VOICE_BUCKET_NAME,
    }
  }
  return {
    REACT_APP_API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3011/api/v1/',
    REACT_APP_API_V2_URL: process.env.REACT_APP_API_V2_URL,
    REACT_APP_API_V3_URL: process.env.REACT_APP_API_V3_URL,
    REACT_APP_BE_API_URL: process.env.REACT_APP_BE_API_URL,
    REACT_APP_PUBLIC_KEY: process.env.REACT_APP_PUBLIC_KEY || 'pk_test_placeholder',
    REACT_APP_DOMAIN: process.env.REACT_APP_DOMAIN,
    REACT_APP_DOMAIN_SOCKETID: process.env.REACT_APP_DOMAIN_SOCKETID,
    REACT_APP_TEST_GIPHY: process.env.REACT_APP_TEST_GIPHY,
    REACT_APP_SHORTURL: process.env.REACT_APP_SHORTURL,
    REACT_APP_SHORTURL_INTERNATIONAL: process.env.REACT_APP_SHORTURL_INTERNATIONAL,
    REACT_APP_OPTOUT: process.env.REACT_APP_OPTOUT,
    REACT_APP_OPTOUT_INTERNATIONAL: process.env.REACT_APP_OPTOUT_INTERNATIONAL,
    REACT_APP_CELLCAST: process.env.REACT_APP_CELLCAST,
    REACT_APP_GOOGLERECAPCHA: process.env.REACT_APP_GOOGLERECAPCHA,
    REACT_APP_GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    REACT_APP_GHL_BASE_URL: process.env.REACT_APP_GHL_BASE_URL,
    REACT_APP_GHL_CLIENT_ID: process.env.REACT_APP_GHL_CLIENT_ID,
    REACT_APP_FE_URL: process.env.REACT_APP_FE_URL,
    REACT_APP_TAWK_TO_PROPERTY_ID: process.env.REACT_APP_TAWK_TO_PROPERTY_ID,
    REACT_APP_TAWK_TO_WIDGET_ID: process.env.REACT_APP_TAWK_TO_WIDGET_ID,
    REACT_APP_JOBADDER_BASE_URL: process.env.REACT_APP_JOBADDER_BASE_URL,
    REACT_APP_JOBADDER_CLIENT_ID: process.env.REACT_APP_JOBADDER_CLIENT_ID,
    REACT_APP_HUBSPOT_CLIENT_ID: process.env.REACT_APP_HUBSPOT_CLIENT_ID,
    REACT_APP_HUBSPOT_CLIENT_SECRET: process.env.REACT_APP_HUBSPOT_CLIENT_SECRET,
    REACT_APP_HUBSPOT_BASE_URL: process.env.REACT_APP_HUBSPOT_BASE_URL,
    REACT_APP_ENABLE_ONBOARDING: process.env.REACT_APP_ENABLE_ONBOARDING,

    REACT_APP_US_URL: process.env.REACT_APP_US_URL,
    REACT_APP_UK_URL: process.env.REACT_APP_UK_URL,
    REACT_APP_AU_URL: process.env.REACT_APP_AU_URL,
    REACT_APP_NZ_URL: process.env.REACT_APP_NZ_URL,
    REACT_APP_ID_URL: process.env.REACT_APP_ID_URL,

    REACT_APP_S3_URL: process.env.REACT_APP_S3_URL,
    REACT_APP_MAX_FILE_SIZE: process.env.REACT_APP_MAX_FILE_SIZE,
    REACT_APP_S3_WALLET_CARD_URL: process.env.REACT_APP_S3_WALLET_CARD_URL,
    REACT_APP_S3_WALLET_CARD_PREVIEW_URL: process.env.REACT_APP_S3_WALLET_CARD_PREVIEW_URL,
    REACT_APP_S3_WALLET_CARD_PREVIEW_BUCKET_NAME:
      process.env.REACT_APP_S3_WALLET_CARD_PREVIEW_BUCKET_NAME,
    REACT_APP_S3_VOICE_URL: process.env.REACT_APP_S3_VOICE_URL,
    REACT_APP_S3_VOICE_BUCKET_NAME: process.env.REACT_APP_S3_VOICE_BUCKET_NAME,
  }

}
